export default "__VITE_ASSET__D_bjhF2$__"